import React, { FC, useCallback } from 'react';
import { Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import { Outlet, useNavigate } from 'react-router-dom';
import oktaConfig from 'config/okta';
import { env } from 'env';

const oktaAuth = new OktaAuth(oktaConfig.oidc);

const OktaController: FC = () => {
  const navigate = useNavigate();

  const restoreOriginalUri = () => {
    navigate(`${env.REACT_APP_BASE_URL}`);
  };

  const onAuthRequired = useCallback(() => {
    navigate(`${env.REACT_APP_BASE_URL}/login`);
  }, []);

  return (
    <Security oktaAuth={oktaAuth} onAuthRequired={onAuthRequired} restoreOriginalUri={restoreOriginalUri}>
      <Outlet />
    </Security>
  );
};

export default OktaController;
